import { StrictMode } from 'react'
import { initSentry } from './sentry'
import { initPostHog } from './posthog'
import { startAnalyticsIdentitySync } from './analytics/identity'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { brand, colors } from './config/theme'

initSentry();
// Envuelto: `initPostHog` toca window.location y el arranque de identidad lee
// localStorage, y los dos corren ANTES de createRoot. En un contexto donde el
// acceso a storage lanza (datos de sitio bloqueados, iframe en sandbox) la
// excepcion escaparia antes de montar React y la app quedaria en blanco:
// perder la analitica es mucho mejor que perder la aplicacion.
try {
  initPostHog();
  // Fuera de React a proposito: sobrevive al doble montaje de StrictMode y lee
  // al usuario ya rehidratado por el middleware `persist` del store.
  startAnalyticsIdentitySync();
} catch (error) {
  console.error("[Analytics] No se pudo inicializar la analitica:", error);
}

// Inject theme brand colors as CSS custom properties for Tailwind pseudo-class usage
const root = document.documentElement;
root.style.setProperty('--brand-primary', brand.primary);
root.style.setProperty('--brand-primary-hover', brand.primaryHover);
root.style.setProperty('--brand-accent', brand.accent);
root.style.setProperty('--color-primary-500', colors.primary['500']);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
